export default "__VITE_ASSET__ZxgcEhxD__"